// Every user-facing string on the Domain Set up page.
// Change wording here, or swap these values for translation lookups later.
// Values that are functions build text from runtime numbers or names.

export const DOMAIN_SETUP_LABELS = {
	tabTitle: 'Roles & Access',

	page: {
		description:
			'Set what this domain includes and the roles every profile starts with. Profiles can only build roles from what is included here; anything you turn off is removed from their builder entirely.',
	},

	ceiling: {
		title: 'Included In This Domain',
		description: 'Turn whole modules or individual pages off. Default and custom roles lose access to anything removed.',
		count: (on, total) => `${on} of ${total} pages included`,
		moduleNone: 'Not included in this domain',
		moduleIncluded: 'Included',
		moduleAll: (count) => `All ${count} pages included`,
		moduleSome: (on, total) => `${on} of ${total} pages included`,
		showPages: (count) => `Pages (${count})`,
		hidePages: 'Hide pages',
		includeAria: (name) => `Include ${name}`,
		minOnePage: 'At least one page must stay included in this domain.',
	},

	roles: {
		title: 'Default Roles',
		description:
			'Every profile on this domain gets these roles, and they are the starting points offered when someone creates a custom role.',
		untitled: 'Untitled role',
		addRole: '+ New default role',
		maxRolesReached: (max) => `A domain can have up to ${max} default roles.`,
		newRoleName: 'New role',
		empty: 'No default roles yet.',
		nameLabel: 'Role name',
		namePlaceholder: 'Role name',
		requiredMark: '* ',
		descLabel: 'Description',
		descPlaceholder: 'One line on who this is for',
		charCount: (used, max) => `${used}/${max}`,
		deleteRole: 'Delete role',
		lockedNote:'Built-in role. Its name, description and access can’t be edited, and it can’t be deleted.',
		deleteConfirmTitle: (name) => `Delete “${name}”?`,
		deleteConfirmBody: 'Profiles keep any custom roles already copied from it.',
		deleteConfirmOk: 'Delete',
		deleteConfirmCancel: 'Cancel',
	},

	access: {
		title: 'Access By Module',
		tally: (open, total) => `${open} of ${total} pages open to this role`,
		moduleAria: (name) => `${name} access`,
		perPage: (count) => `Pages (${count})`,
		hidePages: 'Hide pages',
		hiddenEntirely: 'Hidden entirely',
		singleEdit: 'Can edit',
		singleView: 'Can view',
		editAll: (count) => `Can edit all ${count} pages`,
		viewAll: (count) => `Can view all ${count} pages`,
		mixedPart: (count, levelLabel) => `${count} ${levelLabel.toLowerCase()}`,
		mixedSeparator: ' · ',
	},

	levels: {
		hidden: { label: 'Hidden', blurb: 'Not in the menu, page blocked' },
		view: { label: 'View', blurb: 'Reads real data, changes nothing' },
		edit: { label: 'Edit', blurb: 'Creates and changes records' },
	},

	navPreview: {
		title: 'Navigation',
		aria: 'Navigation preview',
	},

	saveBar: {
		unsaved: 'Unsaved changes to this domain',
		nameRequired: 'Every role needs a name',
		saved: 'Saved. Profiles on this domain now use these settings.',
		saveFailed: 'Failed to save domain setup. Please try again.',
		discard: 'Discard',
		save: 'Save changes',
	},

	// Module name for the Settings pages; other module and page names come from the left nav.
	settingsModule: 'Settings',

	// Role descriptions come from the API (`description`); the seed roles have none.
	defaultRoles: {
		owner: { name: 'Owner', desc: '' },
		admin: { name: 'Administrator', desc: '' },
		readonly: { name: 'Read Only', desc: '' },
	},
};

export default DOMAIN_SETUP_LABELS;
